import { sendMessage } from '../utility/message-bus';
import { Maybe } from 'maybe-not';

export default function openUrl(platformCapabilities: Set<string>) {
    if (!platformCapabilities.has('openURL')) {
        return;
    }
    return function(
        url: string,
        options: {
            showInOverpanel?: boolean;
            nativeBrowserIfInApp?: boolean;
            requiresToken?: boolean;
        }
    ): void {
        sendMessage(
            'openURL',
            Maybe.just(
                JSON.stringify({
                    url,
                    options: {
                        showInModal: options.showInOverpanel,
                        nativeBrowserIfInApp: options.nativeBrowserIfInApp,
                        requiresToken: options.requiresToken === true
                    }
                })
            )
        );
    };
}
